import React from 'react';
import Stats from './Stats';
import SuggestionCard from './SuggestionCard';
import OnceiaL from './OnceiaL';
import Blocked from './Blocked';


const PlanStep = ({ step, email, planLink }) => {
  const {
    number,
    duration,
    text,
    entries,
    identifier,
    title,
    linkText,
    benefitsIntro,
    colorPalette,
  } = step;
  switch (step.type) {
    case 'stats':
      return <Stats number={number} benefitsIntro={benefitsIntro} duration={duration} text={text} entries={entries} identifier={identifier} planLink={planLink} title={title} linkText={linkText} colorPalette={colorPalette} />;
    case 'suggestion':
      return <SuggestionCard text={text} />;
    case 'once':
      return <OnceiaL title={title} text={text} number={number} identifier={identifier} planLink={planLink} linkText={linkText} />;
    case 'blocked':
      return <Blocked number={number} title={title} />;
    default:
      return <div>No encontramos lo que estabas buscando</div>;
  }
};

export default PlanStep;
